import { createContext, useContext } from 'react';

/**
 * Which application the shared pages (sign-in, account, security) run in (ADR 0025): the
 * merchant admin or the platform operator console. Both talk to the same identity routes;
 * the host decides which session the API opens.
 */
export type Surface = 'admin' | 'console';

export const SurfaceContext = createContext<Surface>('admin');

export function useSurface(): Surface {
  return useContext(SurfaceContext);
}
